<template>
    <div class="sidebar">
        <h3 v-t="'product'"></h3>
        <ul>
            <router-link to="/gc111">GC111</router-link>
            <router-link to="/t300">T300</router-link>
            <router-link to="/m55">M55</router-link>
            <router-link to="/lm321">LM321</router-link>
            <router-link to="/cpeLC111">LC111</router-link>
            <router-link to="/t115">T115</router-link>
            <router-link to="/ldw931">LDW931</router-link>
            <router-link to="/lc800">LC800</router-link>
<!--            <router-link to="/d21">D21</router-link>-->
        </ul>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "Sidebar",
    }
</script>

<style scoped>
    .sidebar{
        position: fixed;
        left: 0;
        top: calc(50% - 160px);
        width: 200px;
        border-radius: 10px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.1);
    }
    .sidebar h3{
        background-color: #1962ae;
        color: #FFFFFF;
        font-weight: bold;
        border-radius: 10px 10px 0 0;
        margin: 0;
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .sidebar ul{
        background-color: white;
        border: 1px solid #e9e9e9;
        border-radius: 0 0 10px 10px;
        display: flex;
        flex-direction: column;
    }
    .sidebar ul a{
        padding: 10px 0;
        color: #5e5e5e;
        border-bottom: 1px solid #e9e9e9;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .sidebar ul a:last-child{
        border-radius: 0 0 10px 10px;
    }
    .sidebar ul .router-link-active{
        background-color: orange;
        color: white;
    }
</style>